import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background: ${Cores.PERIGO_ERRO_FUNDO_MAIS_CLARO};
  border: 1px solid ${Cores.PERIGO_ERRO_FUNDO};
  border-radius: 8px;
  padding: 16px 20px;
  margin: 8px 0 8px;
`

export const Texto = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 12px;
`

export const BarraFundo = styled.div`
  width: 100%;
  max-width: 420px;
  height: 10px;
  background: ${Cores.CINZA_3_CLARO};
  border-radius: 8px;
  overflow: hidden;
  margin: 0 0 16px;
`

export const BarraPreenchida = styled.div<{ percentual: number }>`
  height: 100%;
  width: ${props => props.percentual}%;
  background: ${Cores.PRIMARIA_2};
`
